import { OrderSourceFlag } from 'src/app/core/enums/OrderSourceFlag';
import { Pipe, PipeTransform } from '@angular/core';
import { OrderTypeFlag } from 'src/app/core/enums/OrderTypeFlag';

@Pipe({
  name: 'orderTypeIcon'
})
export class OrderTypeIconPipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case OrderSourceFlag.WebDelivery:
      case OrderSourceFlag.AppDelivery:
      case OrderTypeFlag.Delivery: {
        return "icon-delivery1";
      }
      case OrderSourceFlag.WebPickup:
      case OrderSourceFlag.AppPickup:
      case OrderTypeFlag.Pickup: {
        return "icon-pickup1";
      }
      case OrderSourceFlag.WebDineIn:
      case OrderSourceFlag.AppDineIn:
      case OrderTypeFlag.DineIn:
      case OrderSourceFlag.WebQrDineIn:
      case OrderSourceFlag.AppQrDineIn:
      case OrderTypeFlag.QRDineIn: {
        return "icon-order-type-alt";
      }
      case OrderSourceFlag.WebQrTakeaway:
      case OrderSourceFlag.AppQrTakeaway:
      case OrderTypeFlag.QRTakeaway: {
        return "icon-pickup-alt";
      }
      default: {
        return "";
      }
    }
  }

}
